import script from "./ReturnPolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnPolicyView.vue?vue&type=script&setup=true&lang=js"

import "./ReturnPolicyView.vue?vue&type=style&index=0&id=0bb81423&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb81423"]])

export default __exports__